import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Get_Last_200_Comment_For_Ddmin_Dashboard_Action,
  GetAllActionsDatadashboardMarketer_action,
} from '../../Redux/Actions/Action_action';

import {
  Get_All_Top_Saller_Action,
} from '../../Redux/Actions/UsersAction';
import {
  Get_Top_Projects_Anlasis_IN_DAshboard_Action,
} from '../../Redux/Actions/Projects_Action';
import { Get_All_Top_Saller_By_Quarter_Action } from '../../Redux/Actions/SalesAction';
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, BarElement,
  PointElement, LineElement, Tooltip, Legend,
} from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';
import { CircularProgress, useTheme } from '@mui/material';
import MonthlySalesStats from './MonthlySalesStats';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Tooltip, Legend);

/* ── helpers ── */
const getInitials = (name = '') =>
  name.split(' ').slice(0, 2).map((w) => w[0]).join('').toUpperCase();

const avatarBgs = ['#1A3ECF','#0D47A1','#004D40','#4A148C','#BF360C','#1B5E20','#880E4F'];
const dotColors = ['#1A3ECF','#B8860B','#7B1FA2','#00838F','#C62828','#2E7D32','#E65100'];

const timeAgo = (dateStr) => {
  if (!dateStr) return '';
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 60)    return `${diff}s ago`;
  if (diff < 3600)  return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

const EXCLUDE = ['Default','No Sales','Default M','Default T','Default S','Deveolper','Dev'];
const accent  = '#1A3ECF';
const gold    = '#B8860B';
const green   = '#10B981';

/* ══════════════════════════════════════════════════════════════════ */
export const LastComments = () => {
  const theme    = useTheme();
  const dark     = theme.palette.mode === 'dark';
  const dispatch = useDispatch();

  /* tokens */
  const surface    = dark ? '#1E1E2E' : '#FFFFFF';
  const border     = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';
  const textPri    = dark ? '#E2E8F0' : '#111827';
  const textSec    = dark ? '#94A3B8' : '#6B7280';
  const commentBg  = dark ? '#2A2A3E' : '#F4F5F7';
  const timelineBg = dark ? 'rgba(255,255,255,0.08)' : '#E8EAF0';

  /* state */
  const [userlogin,         setUserlogin]         = useState(null);
  const [loadingTopSellers, setLoadingTopSellers] = useState(true);
  const [loadingComments,   setLoadingComments]   = useState(false);
  const [loadingMore,       setLoadingMore]       = useState(false);
  const [loadingProjects,   setLoadingProjects]   = useState(true);
  const [allComments,       setAllComments]       = useState([]);
  const [currentPage,       setCurrentPage]       = useState(1);
  const [hasMore,           setHasMore]           = useState(true);
  const [totalComments,     setTotalComments]     = useState(0);

  const lastCommentRef   = useRef(null);
  const commentsPanelRef = useRef(null);

  /* ── user ── */
  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserlogin(JSON.parse(u));
  }, []);

  /* ── projects analysis ── */
  const projectsRaw = useSelector((s) => s?.AllProjects?.GetTop_ProjectsForDashboard);

  useEffect(() => {
    const load = async () => {
      setLoadingProjects(true);
      await dispatch(Get_Top_Projects_Anlasis_IN_DAshboard_Action());
      setLoadingProjects(false);
    };
    load();
  }, [dispatch]);

  const projectsList = (() => {
    const d = projectsRaw;
    if (!d) return null;
    if (Array.isArray(d?.data?.projects)) return d.data.projects;
    if (Array.isArray(d?.projects))       return d.projects;
    if (Array.isArray(d?.data))           return d.data;
    return null;
  })();

  const projectsSummary = (() => {
    const d = projectsRaw;
    if (!d) return null;
    return d?.data?.summary || d?.summary || null;
  })();

  /* ── top sellers ── */
  useEffect(() => {
    const load = async () => {
      setLoadingTopSellers(true);
      await dispatch(Get_All_Top_Saller_Action());
      await dispatch(Get_All_Top_Saller_By_Quarter_Action());
      setLoadingTopSellers(false);
    };
    load();
  }, [dispatch]);

  const restopseller = useSelector((s) => s?.Allusers?.All_Top_Saller) || {};
  const Topsellerarray = (Array.isArray(restopseller?.data) ? restopseller.data : [])
    .filter((s) => !EXCLUDE.includes(s.salesName))
    .sort((a, b) => b.doneDealsCount - a.doneDealsCount);

  const restopQ = useSelector((s) => s?.AllSales?.Get_All_Top_Saler_by_Quarter) || {};
  const Topsellerbyquarterarray = (Array.isArray(restopQ?.data) ? restopQ.data : [])
    .filter((s) => !EXCLUDE.includes(s.salesName));

  /* ── quarter chart ── */
  const currentYear    = new Date().getFullYear();
  const currentQuarter = Math.floor(new Date().getMonth() / 3);
  const qMonths        = [0,1,2].map((i) =>
    new Date(currentYear, currentQuarter * 3 + i).toLocaleString('default', { month: 'short' })
  );
  const quarterRevenue = qMonths.map((_, i) => {
    const key = `${currentYear}-${String(currentQuarter * 3 + i + 1).padStart(2,'0')}`;
    return Topsellerbyquarterarray.reduce((acc, s) => acc + (s.dealsPerMonth?.[key] || 0), 0);
  });
  const quarterTarget = quarterRevenue.map((v) => Math.round(v * 1.3));
  const allQLabels    = [...qMonths, new Date(currentYear, currentQuarter * 3 + 3).toLocaleString('default',{month:'short'})];

  const quarterChartData = {
    labels: allQLabels,
    datasets: [
      { label:'Revenue', data:[...quarterRevenue,0], backgroundColor:accent, borderRadius:6, barPercentage:0.5 },
      { label:'Target',  data:[...quarterTarget, 0], backgroundColor:'rgba(26,62,207,0.15)', borderRadius:6, barPercentage:0.5 },
    ],
  };

  const baseChartOpts = {
    responsive:true, maintainAspectRatio:false,
    plugins:{ legend:{display:false}, tooltip:{mode:'index',intersect:false} },
    scales:{
      x:{ grid:{display:false}, ticks:{color:textSec, font:{size:11}} },
      y:{ grid:{color: dark?'rgba(255,255,255,0.05)':'#F3F4F6'}, ticks:{color:textSec, font:{size:11}} },
    },
  };

  /* ── projects line chart — كل البروجيكتس زي الصورة ── */
  const allProjects      = projectsList || [];
  const conversionValues = allProjects.map((p) => parseFloat(p.conversionRate) || 0);
  const maxConversion    = Math.max(...conversionValues, 0.1);
  const minConversion    = Math.min(...conversionValues, 0);
  const yPadding         = (maxConversion - minConversion) * 0.15 || 0.2;
  const yMin             = Math.max(0, minConversion - yPadding);
  const yMax             = maxConversion + yPadding;

  const trimLabel = (name = '', max = 14) =>
    name.length > max ? name.slice(0, max - 3) + ' ...' : name;

  const projectLineData = allProjects.length > 0 ? {
    labels: allProjects.map((p) => trimLabel(p.projectName || '?')),
    datasets: [
      {
        label               : 'Conversion %',
        data                : conversionValues,
        borderColor         : accent,
        backgroundColor     : 'transparent',
        borderWidth         : 2,
        pointRadius         : 4,                // ✅ نقاط دائرة زي الصورة
        pointBackgroundColor: '#FFFFFF',
        pointBorderColor    : accent,
        pointBorderWidth    : 2,
        pointHoverRadius    : 6,
        tension             : 0.4,
        fill                : false,
      },
    ],
  } : null;

  const projectLineOpts = {
    responsive         : true,
    maintainAspectRatio: false,
    interaction        : { mode: 'index', intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: dark ? '#1E1E2E' : '#FFFFFF',
        borderColor    : dark ? 'rgba(255,255,255,0.12)' : '#E8EAF0',
        borderWidth    : 1,
        titleColor     : dark ? '#E2E8F0' : '#111827',
        bodyColor      : dark ? '#94A3B8' : '#6B7280',
        padding        : 12,
        callbacks: {
          // ✅ عنوان الـ tooltip = اسم البروجيكت الكامل
          title: (items) => {
            const idx = items[0]?.dataIndex;
            return allProjects[idx]?.projectName || items[0]?.label || '';
          },
          // ✅ بيانات كل بروجيكت زي الصورة
          label: (ctx) => {
            const idx = ctx.dataIndex;
            const p   = allProjects[idx];
            if (!p) return '';
            return [
              `Conversion: ${Number(ctx.raw).toFixed(2)}%`,
              `Total Leads: ${(p.totalLeads || 0).toLocaleString()}`,
              `Done Deals: ${(p.totalDoneDeals || 0).toLocaleString()}`,
            ];
          },
          // ✅ مربع لون جنب كل سطر
          labelColor: () => ({
            borderColor    : accent,
            backgroundColor: accent,
            borderWidth    : 2,
            borderRadius   : 3,
          }),
        },
      },
    },
    scales: {
      x: {
        grid : { display: false },
        ticks: {
          color        : textSec,
          font         : { size: 10 },
          maxRotation  : 0,
          minRotation  : 0,
          autoSkip     : false,               // ✅ كل الأسماء تتعرض
        },
        border: { display: false },
      },
      y: {
        min  : yMin,
        max  : yMax,
        grid : { color: dark ? 'rgba(255,255,255,0.05)' : '#F3F4F6' },
        ticks: {
          color   : textSec,
          font    : { size: 10 },
          callback: (v) => Number(v).toFixed(1),
        },
        border: { display: false },
      },
    },
  };

  /* ── comments: fetch first page ── */
  const fetchFirstPage = useCallback(async () => {
    if (!userlogin) return;
    setLoadingComments(true);
    setAllComments([]);
    setCurrentPage(1);
    setHasMore(true);
    try {
      let res;
      if (userlogin?.data?.role === 'Admin')
        res = await dispatch(Get_Last_200_Comment_For_Ddmin_Dashboard_Action(1, 10));
      else if (userlogin?.data?.role === 'Marketer')
        res = await dispatch(GetAllActionsDatadashboardMarketer_action(userlogin?.data?.email, 1, 10));

      const payload = res?.success ? res : res?.data?.success ? res.data : null;
      if (payload) {
        setAllComments(payload.data || []);
        setTotalComments(payload.pagination?.totalItems || payload.totalItems || 0);
        setHasMore(payload.pagination?.hasNextPage || false);
      }
    } catch (e) { console.error(e); }
    finally { setLoadingComments(false); }
  }, [dispatch, userlogin]);

  useEffect(() => { if (userlogin) fetchFirstPage(); }, [userlogin, fetchFirstPage]);

  /* ── comments: fetch next page ── */
  const fetchNextPage = useCallback(async () => {
    if (!userlogin || loadingMore || !hasMore) return;
    setLoadingMore(true);
    const nextPage = currentPage + 1;
    try {
      let res;
      if (userlogin?.data?.role === 'Admin')
        res = await dispatch(Get_Last_200_Comment_For_Ddmin_Dashboard_Action(nextPage, 10));
      else if (userlogin?.data?.role === 'Marketer')
        res = await dispatch(GetAllActionsDatadashboardMarketer_action(userlogin?.data?.email, nextPage, 10));

      const payload = res?.success ? res : res?.data?.success ? res.data : null;
      if (payload && (payload.data || []).length > 0) {
        setAllComments((prev) => [...prev, ...(payload.data || [])]);
        setCurrentPage(nextPage);
        setHasMore(payload.pagination?.hasNextPage || false);
      } else {
        setHasMore(false);
      }
    } catch (e) { console.error(e); }
    finally { setLoadingMore(false); }
  }, [dispatch, userlogin, currentPage, hasMore, loadingMore]);

  /* ── intersection observer ── */
  useEffect(() => {
    if (loadingComments || loadingMore || !hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) fetchNextPage(); },
      { threshold:0.1, rootMargin:'0px 0px 80px 0px' }
    );
    if (lastCommentRef.current) observer.observe(lastCommentRef.current);
    return () => { if (lastCommentRef.current) observer.unobserve(lastCommentRef.current); };
  }, [loadingComments, loadingMore, hasMore, fetchNextPage, allComments]);

  /* ── field extractors ── */
  const getCommentText = (c) =>
    c?.firstcomment?.text || (c?.secondcomment?.text !== '-' && c?.secondcomment?.text) || c?.commentbysales || '';
  const getSalesName   = (c) => c?.sales?.name   || 'Unknown';
  const getLeadName    = (c) => c?.lead?.name    || '';
  const getProjectName = (c) => c?.project?.name || '';

  const Spinner = ({ size = 24, h = 100 }) => (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:h }}>
      <CircularProgress size={size} style={{ color:accent }} />
    </div>
  );
  const NoData = ({ msg }) => (
    <div style={{ textAlign:'center', padding:'24px 0', color:textSec, fontSize:13 }}>{msg}</div>
  );

  const PANEL_H = 480;

  /* ══════════════════════════════════════════════════════════════════ */
  return (
    <div style={{ marginTop:48 }}>
      <hr style={{ border:'none', borderTop:`1px solid ${border}`, marginBottom:36 }} />

      {/* ── ROW 1: charts ── */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))', gap:20, marginBottom:24 }}>

        {/* Quarter */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 24px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
            <div>
              <div style={{ fontWeight:700, fontSize:15, color:textPri }}>Sales Performance for Current Quarter</div>
              <div style={{ fontSize:12, color:textSec, marginTop:3 }}>Revenue distribution across active portfolios</div>
            </div>
            <div style={{ display:'flex', gap:10, alignItems:'center', flexShrink:0 }}>
              {[['Revenue',accent],['Target',gold]].map(([l,c]) => (
                <span key={l} style={{ display:'flex', alignItems:'center', gap:5, fontSize:11, color:textSec }}>
                  <span style={{ width:8, height:8, borderRadius:'50%', background:c, display:'inline-block' }} />{l}
                </span>
              ))}
            </div>
          </div>
          <div style={{ height:220, marginTop:16 }}>
            <Bar data={quarterChartData} options={baseChartOpts} />
          </div>
        </div>

        {/* ✅ Projects Performance — Pure Line Chart زي الصورة */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 24px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:4 }}>
            <div>
              <div style={{ fontWeight:700, fontSize:15, color:textPri }}>Top Projects Performance</div>
              <div style={{ fontSize:12, color:textSec, marginTop:3 }}>Conversion rate across all projects</div>
            </div>
          </div>

          {/* ✅ overflowX scroll عشان كل البروجيكتس تتعرض */}
          <div style={{ overflowX: 'auto', marginTop: 16 }}>
            <div style={{
              height  : 220,
              minWidth: Math.max(600, allProjects.length * 55),
            }}>
              {loadingProjects ? (
                <Spinner h={220} />
              ) : !projectLineData ? (
                <NoData msg="No projects data available" />
              ) : (
                <Line data={projectLineData} options={projectLineOpts} />
              )}
            </div>
          </div>

          {/* summary strip */}
          {!loadingProjects && projectsSummary && (
            <div style={{
              display:'flex', justifyContent:'space-between',
              marginTop:14, paddingTop:12,
              borderTop:`1px solid ${border}`,
              gap:8, flexWrap:'wrap',
            }}>
              {[
                ['Projects',    projectsSummary.totalProjects],
                ['Total Leads', projectsSummary.totalLeads?.toLocaleString()],
                ['Done Deals',  projectsSummary.totalDoneDeals?.toLocaleString()],
                ['Conversion',  projectsSummary.overallConversionRate, green],
              ].map(([label, val, col]) => (
                <div key={label} style={{ textAlign:'center', flex:1 }}>
                  <div style={{ fontSize:10, color:textSec, marginBottom:2 }}>{label}</div>
                  <div style={{ fontSize:17, fontWeight:700, color: col || textPri }}>{val ?? '—'}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ── ROW 2: Top Sellers + Last Comments ── */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr minmax(300px,380px)', gap:20, alignItems:'start' }}>

        {/* TOP SELLERS */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 24px', height:PANEL_H, display:'flex', flexDirection:'column' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, flexShrink:0 }}>
            <span style={{ fontWeight:700, fontSize:16, color:textPri }}>
              Top Sellers for {new Date().toLocaleString('default',{month:'long'})} {new Date().getFullYear()}
            </span>
            <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.08em', background:'#FFF3E0', color:'#E65100', padding:'4px 12px', borderRadius:20 }}>
              GLOBAL RANKING
            </span>
          </div>

          <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1.5fr 1fr', fontSize:10, fontWeight:600, letterSpacing:'0.08em', color:textSec, textTransform:'uppercase', paddingBottom:10, borderBottom:`1px solid ${border}`, marginBottom:4, flexShrink:0 }}>
            <span>Agent Profile</span>
            <span style={{ textAlign:'center' }}>Active Deals</span>
            <span style={{ textAlign:'center' }}>Success Rate</span>
            <span style={{ textAlign:'right' }}>Revenue</span>
          </div>

          <div style={{ overflowY:'auto', flex:1, scrollbarWidth:'thin' }}>
            {loadingTopSellers ? <Spinner /> : Topsellerarray.length === 0 ? <NoData msg="No sales data" /> :
              Topsellerarray.map((sales, idx) => {
                const rate = sales.totalLeadsCount > 0 ? Math.round((sales.doneDealsCount / sales.totalLeadsCount) * 100) : 0;
                const rev  = sales.amount ? `$${(sales.amount/1e6).toFixed(1)}M` : '—';
                const titles = ['Senior Partner','Luxury Specialist','Portfolio Associate'];
                return (
                  <div key={sales.salesId} style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1.5fr 1fr', alignItems:'center', padding:'12px 0', borderBottom: idx < Topsellerarray.length-1 ? `1px solid ${border}` : 'none' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                      <div style={{ width:40, height:40, borderRadius:'50%', background:avatarBgs[idx % avatarBgs.length], display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:700, color:'#fff', flexShrink:0 }}>
                        {getInitials(sales.salesName)}
                      </div>
                      <div>
                        <div style={{ fontWeight:600, fontSize:13, color:textPri }}>{sales.salesName}</div>
                        <div style={{ fontSize:10, color:textSec, textTransform:'uppercase', letterSpacing:'0.06em' }}>{titles[idx] || 'Sales Agent'}</div>
                      </div>
                    </div>
                    <div style={{ textAlign:'center', fontSize:15, fontWeight:600, color:textPri }}>{sales.doneDealsCount}</div>
                    <div style={{ padding:'0 12px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <div style={{ flex:1, height:4, background: dark?'rgba(255,255,255,0.08)':'#E8EAF0', borderRadius:99 }}>
                          <div style={{ height:'100%', width:`${Math.min(rate,100)}%`, background:accent, borderRadius:99 }} />
                        </div>
                        <span style={{ fontSize:12, fontWeight:700, color:accent, minWidth:32 }}>{rate}%</span>
                      </div>
                    </div>
                    <div style={{ textAlign:'right', fontSize:13, fontWeight:700, color:textPri }}>{rev}</div>
                  </div>
                );
              })
            }
          </div>
        </div>

        {/* LAST COMMENTS */}
        <div style={{ background:surface, border:`1px solid ${border}`, borderRadius:16, padding:'22px 20px', height:PANEL_H, display:'flex', flexDirection:'column' }}>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4, flexShrink:0 }}>
            <span style={{ fontWeight:700, fontSize:17, color:textPri }}>Last Comments</span>
            <span style={{ fontSize:20, color:textSec, cursor:'pointer', letterSpacing:2 }}>⋮</span>
          </div>

          {!loadingComments && allComments.length > 0 && (
            <div style={{ marginBottom:10, flexShrink:0 }}>
              <span style={{ fontSize:11, color: !hasMore ? green : textSec, fontWeight:600 }}>
                {!hasMore
                  ? `✓ All ${totalComments} comments loaded`
                  : `Showing ${allComments.length} of ${totalComments}`}
              </span>
            </div>
          )}

          <div ref={commentsPanelRef} style={{ flex:1, overflowY:'auto', scrollbarWidth:'thin', paddingRight:4 }}>
            {loadingComments ? (
              <Spinner />
            ) : allComments.length === 0 ? (
              <NoData msg="No comments" />
            ) : (
              <div style={{ position:'relative' }}>
                <div style={{ position:'absolute', left:3, top:6, bottom:6, width:1.5, background:timelineBg, borderRadius:99 }} />
                <div style={{ display:'flex', flexDirection:'column', gap:20, paddingLeft:20 }}>
                  {allComments.map((comment, idx) => (
                    <div
                      key={comment.commentId || idx}
                      style={{ position:'relative' }}
                      ref={idx === allComments.length - 1 ? lastCommentRef : null}
                    >
                      <div style={{ position:'absolute', left:-21, top:4, width:9, height:9, borderRadius:'50%', background:dotColors[idx % dotColors.length], border:`2px solid ${surface}`, zIndex:1 }} />
                      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:2 }}>
                        <span style={{ fontWeight:700, fontSize:14, color:textPri }}>{getSalesName(comment)}</span>
                        <span style={{ fontSize:11, color:textSec, flexShrink:0, marginLeft:8 }}>
                          {timeAgo(comment.stageDate || comment.createdAt)}
                        </span>
                      </div>
                      <div style={{ marginBottom:8 }}>
                        {getProjectName(comment) && (
                          <span style={{ fontSize:10, fontWeight:700, letterSpacing:'0.1em', color:accent, textTransform:'uppercase' }}>
                            {getProjectName(comment)}
                          </span>
                        )}
                        {getLeadName(comment) && (
                          <span style={{ fontSize:10, color:textSec, marginLeft: getProjectName(comment) ? 6 : 0 }}>
                            • {getLeadName(comment)}
                          </span>
                        )}
                      </div>
                      <div style={{ background:commentBg, borderRadius:10, padding:'10px 12px', fontSize:13, color:textSec, lineHeight:1.6 }}>
                        {getCommentText(comment) || '—'}
                      </div>
                    </div>
                  ))}

                  {loadingMore && (
                    <div style={{ textAlign:'center', padding:'12px 0' }}>
                      <CircularProgress size={18} style={{ color:accent }} />
                      <div style={{ fontSize:11, color:textSec, marginTop:4 }}>Loading more…</div>
                    </div>
                  )}

                  {!hasMore && totalComments > 0 && (
                    <div style={{ textAlign:'center', padding:'12px 0 8px', fontSize:11, color:green, fontWeight:700 }}>
                      ✓ You've seen all {totalComments} comments
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {allComments.length > 0 && (
            <div style={{ paddingTop:14, flexShrink:0 }}>
              <button
                style={{ width:'100%', padding:'11px 0', background: dark?'#2A2A3E':'#F4F5F7', border:'none', borderRadius:10, cursor:'pointer', fontSize:13, fontWeight:600, color:textPri, transition:'background 0.15s' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = dark?'#3A3A5E':'#E8EAF0'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = dark?'#2A2A3E':'#F4F5F7'; }}
              >
                View All Activity
              </button>
            </div>
          )}
        </div>
      </div>

      <div style={{ marginTop:32 }}>
        <MonthlySalesStats salesData={Topsellerbyquarterarray} />
      </div>
    </div>
  );
};
